module.exports = __webpack_public_path__ + "img/total-stt-hanging.ad660a6a.svg";